import { gql } from '@apollo/client';

import type * as GraphQLTypes from '../../../graphql/types.generated';
export type EditSsoConfigurationMutationVariables = GraphQLTypes.Exact<{
  input: GraphQLTypes.CreateSsoConfigurationInput;
}>;

export type EditSsoConfigurationMutationResult = { __typename?: 'Mutation' } & {
  createSsoConfiguration: { __typename?: 'CreateSsoConfigurationPayload' } & Pick<
    GraphQLTypes.CreateSsoConfigurationPayload,
    'accountId' | 'connectionName'
  > & { errors?: GraphQLTypes.Maybe<Array<{ __typename?: 'Error' } & Pick<GraphQLTypes.Error, 'message'>>> };
};

export const EditSsoConfigurationDocument = gql`
  mutation editSsoConfiguration($input: CreateSsoConfigurationInput!) {
    createSsoConfiguration(input: $input) {
      accountId
      connectionName
      errors {
        message
      }
    }
  }
`;
